import { render } from "./ChangePassword.vue?vue&type=template&id=7155b38a&scoped=true&lang=pug"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=7155b38a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7155b38a"

export default script